import { render, staticRenderFns } from "./CalendarHome.vue?vue&type=template&id=3b7aa39e&scoped=true"
import script from "./CalendarHome.vue?vue&type=script&lang=js"
export * from "./CalendarHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7aa39e",
  null
  
)

export default component.exports